/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

const ProtocolTypes = {
  kafka: 'kafka',
  kafkaSecure: 'kafka-secure'
};

const displayType = (type) => {
  switch (type) {
    case ProtocolTypes.kafka:
    case ProtocolTypes.kafkaSecure:
      return 'Kafka';
    default:
      return type;
  }
};

const isKafka = (type) => type === ProtocolTypes.kafka || type === ProtocolTypes.kafkaSecure;
const isKafkaSecure = (type) => type === ProtocolTypes.kafkaSecure;

export { ProtocolTypes, displayType, isKafka, isKafkaSecure };
